import { useLocation, useNavigate } from "react-router-dom";
import routes from "@/config/routes.ts";
import SadEmojiIcon from "@/components/icons/SadEmojiIcon.tsx";
import { Button } from "@/components/ui/Button.tsx";

interface ConfirmModalState {
  countBookedCorrections: number;
  hoursWriting: number;
}

function MobileLiveCorrectionError() {
  const location = useLocation();
  const { countBookedCorrections, hoursWriting } = location.state as ConfirmModalState;
  const navigate = useNavigate();

  return (
    <div className={"w-full h-full max-w-md mx-auto my-10 space-y-10"}>
      <div className="flex flex-col gap-y-8 justify-center items-center h-full">
        <div className={"flex flex-col justify-center items-center w-full"}>
          <div className={"gap-y-4 flex flex-col justify-center items-center"}>
            <SadEmojiIcon className={"w-16 h-16 fill-brand-deep"} />
            <h3
              className={"text-light text-4xl font-semibold pt-3 text-center"}
            >
              You can&apos;t book <br /> a live correction
            </h3>
          </div>
        </div>
        <div className="flex flex-col items-center gap-y-4">
          <p className={"text-center text-light-350 text-lg font-normal"}>
            You have booked {countBookedCorrections} live corrections for <br />
            this period. Contact us for assistance. 
            {/* You will be able to book other <br />
            sessions in the following month */}
          </p>
          <div
            className={
              "w-40 h-12 border border-light-350 text-light font-semibold text-3xl rounded-lg flex justify-center items-center"
            }
          >{`${countBookedCorrections} / ${hoursWriting}`}</div>
          <p className={"text-15px text-center font-semibold text-light"}>
            booked corrections
          </p>

          <div className="mt-6 mx-auto flex max-w-2xl gap-x-5 w-full">
            <Button
              className="w-full !text-light !h-[59px] !rounded-[11px]"
              onClick={() => {
                navigate(routes.exercises);
              }}
            >
              EXIT
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileLiveCorrectionError;
